__turbopack_context__.v({
  "fadeEnterActiveLeft": "Images-module__InHTdq__fadeEnterActiveLeft",
  "fadeEnterActiveRight": "Images-module__InHTdq__fadeEnterActiveRight",
  "fadeEnterLeft": "Images-module__InHTdq__fadeEnterLeft",
  "fadeEnterRight": "Images-module__InHTdq__fadeEnterRight",
  "fadeExitActiveLeft": "Images-module__InHTdq__fadeExitActiveLeft",
  "fadeExitActiveRight": "Images-module__InHTdq__fadeExitActiveRight",
  "fadeExitLeft": "Images-module__InHTdq__fadeExitLeft",
  "fadeExitRight": "Images-module__InHTdq__fadeExitRight",
});
